import type { CalculationType } from '../../../types';
import { useCalculations } from '../../calculations-context';
import { Divider } from '../../results/divider';
import {
  processCalculatorValue,
  useCalculatorValueFormatter
} from '../../utils';
import { ResultPrimary } from './result-primary';
import { ResultSecondary } from './result-secondary';

export type ResultProps = {
  calculation: CalculationType;
  value?: number | string;
  formatter?: (value?: number | string) => string;
};

export function Result({ calculation }: ResultProps) {
  const calculations = useCalculations();
  const value = calculations[calculation.id];
  const resultValue = processCalculatorValue(calculation.format, value);
  const valueFormatter = useCalculatorValueFormatter(calculation.format);

  return (
    <>
      {
        {
          primaryResult: (
            <ResultPrimary
              value={resultValue}
              calculation={calculation}
              formatter={valueFormatter}
            />
          ),
          secondaryResult: (
            <ResultSecondary
              value={resultValue}
              calculation={calculation}
              formatter={valueFormatter}
            />
          )
        }[calculation.resultType]
      }

      {calculation.divider && <Divider />}
    </>
  );
}
